import url from 'libraries/front-end-core/core/url'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { QA_MENU } from 'constants/controllers'

export default new Controller({
  name: 'LegacyQaMenuRedirect',
  route: ':aol/:flavour/qa',
  controller (Router, { params }) {
    const target = url(QA_MENU, params)
    replaceUrl(target)
  }
})
